import { FileAction, FileState } from 'store/data/file';
import { domainUtility } from 'utility';

const initialState: FileState = { allIds: [], byId: {} };

const fileReducer = (
  state: FileState = initialState,
  action: FileAction,
): FileState => {
  switch (action.type) {
    case 'data/file/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/file/SET':
      return domainUtility.set(state, action.payload);
    case 'data/file/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/file/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/file/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default fileReducer;
